module.exports = __webpack_public_path__ + "static/media/image (8).35752fa8.png";